exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".category-check[data-v-61f57a60] {\n  position: absolute;\n  right: 16px;\n}\n.attachable-name[data-v-61f57a60] {\n  max-width: 95%;\n  overflow: hidden;\n  white-space: nowrap;\n  text-overflow: ellipsis;\n}", ""]);

// exports
